import React, { useEffect, useMemo, useState } from "react";
import { FiExternalLink } from "react-icons/fi";
import Modal from "../Modal";

function Image({ src, alt = "Image", placeholder = "", className = "", style = {}, onClick = () => {}, preview = false }) {
	const [PreviewPhoto, setPreviewPhoto] = useState();
	const normalizeSrc = (value) => {
		if (!value) return "";
		if (/^(https?:|data:|blob:|\/)/i.test(value)) return value;
		// Handle raw storage keys by making path absolute from host root.
		return `/${value}`;
	};
	const normalizedSource = useMemo(() => normalizeSrc(src), [src]);
	const normalizedPlaceholder = useMemo(() => normalizeSrc(placeholder), [placeholder]);
	const [displaySource, setDisplaySource] = useState(normalizedSource || normalizedPlaceholder);

	useEffect(() => {
		setDisplaySource(normalizedSource || normalizedPlaceholder);
	}, [normalizedSource, normalizedPlaceholder]);

	const previewAvailable = preview && !!normalizedSource && displaySource === normalizedSource; // preview only for valid primary source

	return (
		<div onClick={onClick} className={`group overflow-hidden bg-light relative ${previewAvailable ? "cursor-pointer" : ""} ${className}`} style={style}>
			{displaySource && (
				<img
					src={displaySource}
					alt={alt}
					className="object-cover w-full h-full"
					onError={() => {
						if (normalizedPlaceholder && displaySource !== normalizedPlaceholder) {
							setDisplaySource(normalizedPlaceholder);
						}
					}}
				/>
			)}
			{previewAvailable && (
				<div
					onClick={(e) => {
						e.stopPropagation();
						setPreviewPhoto(true);
					}}
					className="absolute inset-0 justify-center hidden bg-black bg-opacity-50 text-canvas group-hover:align-center"
				>
					<FiExternalLink />
				</div>
			)}
			<Modal open={PreviewPhoto} onClose={() => setPreviewPhoto()} contentClass="!max-w-[50rem]">
				<img src={normalizedSource} alt="Preview" className="w-full" />
			</Modal>
		</div>
	);
}

export default Image;
